import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import DesignOptions from "@/pages/DesignOptions";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App min-h-screen bg-[color:var(--laa-ink)]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/design-options" element={<DesignOptions />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "var(--laa-ink-2)",
            border: "1px solid var(--laa-hairline)",
            color: "var(--laa-ivory)",
          },
        }}
      />
    </div>
  );
}

export default App;
